<template>
  <section id="admin-list" class="content">

    <section class="content-toolbar">
      <button
        class="btn btn-primary"
        @click="displayAdminCreationBox">
        Ajouter un administrateur
      </button>
    </section>

    <message
      :obj=administrators.message
      hide-mutation-type="CLEAR_ADMINISTRATORS_MESSAGE">
    </message>

    <change-password-modal
      v-if="administrators.passwordChangeModal.visible"
      hide-dispatch-action="closeAdministratorPasswordChangeModal"
      change-dispatch-action="changeAdministratorPassword"
      :can-only-exit-modal="administrators.passwordChangeModal.canOnlyExitModal"
      :is-loading="administrators.passwordChangeModal.loading"
      :message="administrators.passwordChangeModal.message"
      :selected-person="selectedAdmin">
    </change-password-modal>

    <deactivation-modal
      v-if="showConfirmModal"
      title="Désactivation d'un administrateur"
      :data="selectedAdmin"
      @close="showConfirmModal = false"
      @confirm="deactivateAdmin">
    </deactivation-modal>

    <person-create-view
      v-if="administrators.isActiveCreatedAdminModal"
      @close="resetCreateModal"
      @confirm="createAdministrator">
    </person-create-view>


    <content-row
      v-for="a in sortedAdministrators"
      :is-open="selectedAdmin.id === a.id"
      :mark-as-deactivated="!a.actif"
      @open="openAdminDetails(a)"
      @close="closeAdminDetails()">

      <div slot="main-close">
        <div class="col-sm-6 col-md-3">
          <div class="title-item">PRÉNOM, NOM</div>
          <div class="text-item">{{ a.prenom }} {{ a.nom }}</div>
        </div>
      </div>

      <div slot="main-open">
        <div class="col-sm-4 col-md-2">
          <div class="title-item">PRÉNOM</div>
          <div class="text-item" v-if="editingAdminId !== a.id">{{ a.prenom }}</div>
          <input class="col-sm-12 form-control input-edit" type="text" v-if="editingAdminId === a.id"
                 v-model="edit.prenom"/>
          <div class="error-message">
            {{ prenomValidationMessage }}
          </div>
        </div>
        <div class="col-sm-4 col-md-2">
          <div class="title-item">NOM</div>
          <div class="text-item" v-if="editingAdminId !== a.id">{{ a.nom }}</div>
          <input v-if="editingAdminId === a.id" class="col-sm-12 form-control input-edit" type="text"
                 v-model="edit.nom"/>
          <div class="error-message">
            {{ nomValidationMessage }}
          </div>
        </div>
        <div class="col-sm-4 col-md-2">
          <div class="title-item">LOGIN</div>
          <div class="text-item break-word" v-if="editingAdminId !== a.id">{{ a.login }}</div>
          <input v-if="editingAdminId === a.id" class="col-sm-12 form-control input-edit" type="text"
                 v-model="edit.login" :disabled="true"/>
        </div>
        <div class="col-sm-6 col-md-3">
          <div class="title-item">EMAIL</div>
          <div class="text-item" v-if="editingAdminId !== a.id">{{ a.email }}</div>
          <input class="col-sm-12 form-control input-edit" type="text" v-if="editingAdminId === a.id"
                 v-model="edit.email"/>
          <div class="error-message">
            {{ emailValidationMessage }}
          </div>
        </div>
        <div class="col-sm-4 col-md-2">
          <div class="title-item">MOT DE PASSE</div>
          <div class="text-item text-item--password">********</div>
          <a v-if="editingAdminId === a.id" class="change-password"
             v-on:click="displayChangePasswordModal">Modifier</a>
        </div>
      </div>

      <div slot="bottom-actions"
           v-if="selectedAdmin.id === a.id">
        <activate-deactivate-button
          :state="!a.actif"
          @activate="activateAdministrator(a)"
          @deactivate="showConfirmModal = true">
        </activate-deactivate-button>
        <modify-save-button
          :state="editingAdminId !== a.id"
          @modify="openEditionMode(a)"
          @save="updateAdministratorInfo()">
        </modify-save-button>
      </div>

    </content-row>

  </section>
</template>

<script>
import _ from 'lodash'
import {mapState} from 'vuex'
import ActivateDeactivateButton from '../../shared/ActivateDeactivateButton'
import ChangePasswordModal from '../../shared/ChangePasswordModal'
import DeactivationModal from '../../shared/DeactivationModal'
import Message from '../../shared/Message'
import ModifySaveButton from '../../shared/ModifySaveButton'
import PersonCreateView from '../../shared/PersonCreate'
import ContentRow from '../../shared/ContentRow'

export default {
  components: {
    ActivateDeactivateButton,
    ChangePasswordModal,
    DeactivationModal,
    Message,
    ModifySaveButton,
    PersonCreateView,
    ContentRow,
  },
  computed: {
    ...mapState([
      'administrators',
    ]),
    sortedAdministrators () {
      console.log('get sorted')
      return this.$store.state.administrators.data.sort(function (a, b) {
        let nameA = `${a.prenom} ${a.nom}`
        let nameB = `${b.prenom} ${b.nom}`
        return nameA.localeCompare(nameB)
      })
    },
  },
  data: function () {
    return {
      edit: {
        prenom: '',
        nom: '',
        login: '',
        email: '',
        password: '',
      },
      selectedAdmin: {
        id: null
      },
      editingAdminId: null,
      showConfirmModal: false,
      prenomValidationMessage: '',
      nomValidationMessage: '',
      emailValidationMessage: '',
    }
  },
  methods: {
    activateAdministrator: function (admin) {
      this.$store.dispatch('activateAdministratorV2', this.selectedAdmin)
    },
    closeAdminDetails: function () {
      this.selectedAdmin.id = null
    },
    /*     closeEditionMode: function () {
          this.editingAdminId = null
          console.log("updaaate it")
        }, */
    createAdministrator: function (newAdmin) {
      console.log('newAdmin :::: ', newAdmin)
      this.$store.dispatch('createAdministratorV2', newAdmin)
    },
    deactivateAdmin: function () {
      this.showConfirmModal = false
      console.log('ya ya ya ya ya ya')
      this.$store.dispatch('deactivateAdministratorV2', this.selectedAdmin)
    },
    displayAdminCreationBox: function () {
      this.$store.commit('CLEAR_ADMINISTRATORS_MESSAGE')
      this.$store.commit('DISPLAY_ADMINISTRATOR_CREATE_BOX')
    },
    displayChangePasswordModal: function () {
      this.$store.dispatch('showAdministratorPasswordChangeModal')
    },
    openAdminDetails: function (administrator) {
      this.selectedAdmin = _.cloneDeep(administrator)
      this.emailValidationMessage = ''
      this.nomValidationMessage = ''
      this.prenomValidationMessage = ''
      console.log('selectedAdmin => ', this.selectedAdmin)
    },
    openEditionMode: function (administrator) {
      this.edit.prenom = administrator.prenom
      this.edit.nom = administrator.nom
      this.edit.login = administrator.login
      this.edit.email = administrator.email
      this.editingAdminId = administrator.id
    },
    resetCreateModal: function () {
      this.$store.commit('HIDE_ADMINISTRATOR_CREATE_BOX')
      this.$store.commit('CLEAR_ADMINISTRATORS_MESSAGE')
    },
    updateAdministratorInfo: function () {
      console.log('updaaate')
      this.selectedAdmin.prenom = this.edit.prenom
      this.selectedAdmin.nom = this.edit.nom
      this.selectedAdmin.email = this.edit.email
      console.log('selected Admin => ', this.selectedAdmin)
      console.log('selected EDIT => ', this.selectedAdmin)
      if (this.validatePrenom() && this.validateNom() && this.validateEmail()) {
        console.log('let\'s go')
        this.$store.dispatch('updateAdministratorV2', this.selectedAdmin)
        this.editingAdminId = null
      }

    },
    validatePrenom () {
      console.log('this.person.firstname ::: ', this.edit.prenom)
      if (this.edit.prenom.trim() === '') {
        console.log('error first name ')
        this.prenomValidationMessage =
          'Le prénom ne doit pas être vide.'
        return false
      } else {
        this.prenomValidationMessage = ''
        return true
      }
    },
    validateNom () {
      console.log('this.person.firstname ::: ', this.edit.nom)
      if (this.edit.nom.trim() === '') {
        console.log('error first name ')
        this.nomValidationMessage =
          'Le prénom ne doit pas être vide.'
        return false
      } else {
        this.nomValidationMessage = ''
        return true
      }
    },
    validateEmail () {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (!emailRegex.test(this.edit.email)) {
        this.emailValidationMessage =
          'Vous devez renseigner une adresse email valide.'
        return false
      } else {
        this.emailValidationMessage = ''
        return true
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('fetchAdministratorsV2')
  },
  beforeDestroy() {
    console.log("Leaving the page - Perform cleanup here");
    this.resetCreateModal()
  }
}
</script>
<style lang="scss">
.error-message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// AdministratorsList.vue?6d3798be